<template>
  <div class="Entire">
    <div class="empty" v-if="historyList.length <= 0">
      <el-empty description="暂无历史记录"></el-empty>
    </div>
    <div class="list" v-for="(item, index) in historyList" :key="index">
      <div class="list-one">
        <div class="left">
          <div class="img" v-if="item.coverPic"
          :style="'background: url('+ item.coverPic +') no-repeat top center /cover'"></div>
          <el-button @click="lookBtn(item)">点击查看</el-button>
          <!-- <p class="book-status">收藏状态</p> -->
        </div>
        <div class="right">
          <p class="book-name">
            {{toStr(item.bookName)}}
          </p>
          <ul>
            <li>
              <p>书籍id</p>
              <p :bookId="item.bookId">{{item.bookId}}</p>
            </li>
            <li>
              <p style="padding-left:4px">作者</p>
              <p style="padding-left: 56px">{{toStr(item.bookInfo.author)}}</p>
            </li>
            <li>
              <p style="padding-left:4px">版本</p>
              <p style="padding-left: 56px">{{toStr(item.bookInfo.edition)}}</p>
            </li>
            <li>
              <p style="padding-left:4px">册次</p>
              <p style="padding-left: 56px">{{toStr(item.bookInfo.ceci)}}</p>
            </li>
          </ul>
        </div>
      </div>
       <div class="list-two">
        <div class="left">
          <div class="img" v-if="item.coverPic"
          :style="'background: url('+ item.coverPic +') no-repeat top center /cover'"></div>
          <el-button @click="lookBtn(item)">点击查看</el-button>
          <!-- <p class="book-status">收藏状态</p> -->
        </div>
        <div class="right">
          <p class="book-name">
            {{toStr(item.bookName)}}
          </p>
          <ul>
            <li>
              <p>书籍id</p>
              <p>{{item.bookId}}</p>
            </li>
            <li>
              <p style="padding-left:4px">作者</p>
              <p style="padding-left: 56px">{{toStr(item.bookInfo.author)}}</p>
            </li>
            <li>
              <p style="padding-left:4px">版本</p>
              <p style="padding-left: 56px">{{toStr(item.bookInfo.edition)}}</p>
            </li>
            <li>
              <p style="padding-left:4px">册次</p>
              <p style="padding-left: 56px">{{toStr(item.bookInfo.ceci)}}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { listReadHistory,getBookStatusByBookId } from "@/utils/router/reader.api";
export default {
  data() {
    return {
      historyList: [],
    };
  },
  methods: {
    toStr(val) {
      return val ? val.toString() : '无'
    },
    lookBtn(item) {
      this.$router.push({
        path: '/detail',
        query: {
          key: this.$UrlEncode.encode(JSON.stringify({
            bookId: item.bookId
          }))
        }
      })
    },
    getStatus() {
      getBookStatusByBookId({
        userId: this.$store.state.userInfo.userId,
        // bookId:
      }).then(res=> {

      })
    }
  },
  created() {
    listReadHistory({
      userId: this.$store.state.userInfo.userId,
      typeId: this.$store.state.typeId,
      timeType: 1,
    }).then((res) => {
      this.historyList = res.data.data.list;
      this.historyList = this.historyList.map(data=> {
        this.bookId = data.bookId
        if (!data.coverPic || data.coverPic == '/') {
          data.coverPic = '../../../assets/img/reader/history.png'
         }
          return data
      })
    });
    this.getStatus()
  },
};
</script>

<style lang="less" scoped>
.list {
  flex: 1;
  height: 286px;
  display: flex;
  margin-bottom: 48px;
  .list-one,.list-two {
    width: 400px;
    display: flex;
    .left {
      width: 124px;
      border-right: 2px solid #f0e9df;
      padding-right: 10px;
      .img {
        width: 114px;
        height: 166px;
        margin-top: 10px;
      }
      .el-button {
        width: 114px;
        height: 30px;
        font-size: 14px;
        margin-top: 20px;
        line-height: 13px;
      }
      .book-status {
        color: #d68c0a;
        font-size: 20px;
        margin-top: 30px;
        margin-left: 15px;
        letter-spacing: 2px;
      }
    }
    .right {
      flex: 1;
      padding-left: 12px;
      .book-name {
        height: 80px;
        color: #343434;
        font-size: 20px;
        line-height: 40px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
      ul {
        li {
          display: flex;
          font-size: 18px;
          letter-spacing: 2px;
          line-height: 54px;
        }
        li p:first-child {
          color: #797979;
        }
        li p:last-child {
          width: 190px;
          color: #404040;
          padding-left: 40px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
  .list-two {
    margin-left: 60px;
  }
}
.empty {
  position: relative;
  left: 332px;
  top: 30px;
}
</style>
